import script from "./AnimationHeart.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationHeart.vue?vue&type=script&setup=true&lang=js"

import "./AnimationHeart.vue?vue&type=style&index=0&id=3b947179&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b947179"]])

export default __exports__